module.exports = __webpack_public_path__ + "static/media/anne-laure-conversation.ce0b1ce2.png";